// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"336ff3c1","455":"a8227506","977":"9e3561f6"}[chunkId] + ".chunk.js";
};